import React, { useEffect } from 'react';
import { parse } from 'query-string';
import { connect } from 'react-redux';
import { useLocation, Redirect } from 'react-router-dom';
import { records as userRecords } from '@saucelabs/sl-module-user';

import { selectors as plansSelectors, actions as plansActions } from '../ducks/plans';
import { selectors as subscriptionsSelectors, actions as subscriptionsActions } from '../ducks/subscriptions';
import { selectors as purchaseSelectors } from '../ducks/purchase';
import {
  INTERVAL_KEY,
  ROUTE_PARENT_SECTION,
  EMAIL_SUPPORT_PLAN_UPDATE,
} from '../constants';
import { Plan } from '../records/Plan';
import { Subscription } from '../records/Subscription';
import { PlanConfiguration } from '../records/PlanConfiguration';
import { EmailSupport } from '../components/EmailSupport';

interface PartialState {
  user: typeof userRecords.UserRecord,
}

export interface Props {
  user: typeof userRecords.UserRecord,
  usagePlans: { [key: string]: Plan },
  activeSubscriptions: Subscription[],
  fetchPlans: () => void,
  fetchSubscriptions: () => void,
  usageConfig: PlanConfiguration,
}

export const EmailSupportContainer: React.FC<Props> = ({
  user,
  usagePlans,
  usageConfig,
  activeSubscriptions,
  fetchPlans,
  fetchSubscriptions,
}) => {
  const location = useLocation();
  const { action, hide_credits: hideCredits } = parse(location.search);
  const hasValidAction = action === EMAIL_SUPPORT_PLAN_UPDATE;
  useEffect(() => {
    if (hasValidAction) {
      fetchPlans();
      fetchSubscriptions();
    }
  }, []);

  if (!hasValidAction) {
    return (
      <Redirect to={`/${ROUTE_PARENT_SECTION}`} />
    );
  }

  const [usageSubscription] = activeSubscriptions;
  const plan: Plan | undefined = usagePlans[usageConfig[INTERVAL_KEY]];
  const currentCreditBlocksAmount = usageSubscription ?
    usageSubscription.getCreditBlocksAmount() : 0;

  return (
    <EmailSupport
      action={action}
      creditBlockPrice={(plan?.getPriceForCreditBlock() || 0)}
      currentCreditBlocksAmount={currentCreditBlocksAmount}
      hideCredits={hideCredits === 'true' || false}
      user={user}
    />
  );
};

export const mapStateToProps = (state: PartialState) => ({
  usageConfig: purchaseSelectors.getUsageConfigSelector(state),
  user: state.user,
  usagePlans: plansSelectors.getUsageCreditsPlansSelector(state),
  activeSubscriptions: subscriptionsSelectors.getUsageSubscriptionsSelector(state),
});

const mapDispatchToProps = {
  fetchPlans: plansActions.fetchPlansAction,
  fetchSubscriptions: subscriptionsActions.fetchSubscriptions,
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailSupportContainer);
